import { type ImageLoaderProps } from 'next/image';

export const DEFAULT_IMAGE_QUALITY = 85;

const replaceAbsolutePathWithRelative = (url: string): string => {
  const absolutePathPattern = /^https?:\/\/[^/]+/u;
  return url.replace(absolutePathPattern, '');
};

const getRootUrl = (url: string): string | null => {
  try {
    const { hostname, protocol } = new URL(url);
    return `${protocol}//${hostname}`;
  } catch {
    return null;
  }
};

export const imageLoader = ({ quality, src, width }: ImageLoaderProps) => {
  const rootUrl = getRootUrl(src);
  const relativePath = replaceAbsolutePathWithRelative(src);
  const nextSiteUrl =
    process.env.NODE_ENV === 'development'
      ? 'https://cms.int.mdrt.org'
      : process.env.NEXT_PUBLIC_BASE_URL;
  const optimizelySiteUrl = process.env.OPTIMIZELY_SITE_URL;
  const assetsSiteUrl = 'https://assets.mdrt.org';

  switch (rootUrl) {
    case nextSiteUrl:
    case optimizelySiteUrl:
      return `${rootUrl}/cdn-cgi/image/width=${width},quality=${
        quality ?? DEFAULT_IMAGE_QUALITY
      },format=auto${relativePath}`;
    case assetsSiteUrl:
      return `${src}?width=${width}&quality=${quality ?? DEFAULT_IMAGE_QUALITY}&format=auto`;
    default:
      return src;
  }
};
